import { render, staticRenderFns } from "./quickGuidance.vue?vue&type=template&id=6a6a3318&scoped=true"
import script from "./quickGuidance.vue?vue&type=script&lang=js"
export * from "./quickGuidance.vue?vue&type=script&lang=js"
import style0 from "./quickGuidance.vue?vue&type=style&index=0&id=6a6a3318&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6a3318",
  null
  
)

export default component.exports